import { render } from "./IconBarcodeLinkHistory.vue?vue&type=template&id=bb5d6112"
import script from "./IconBarcodeLinkHistory.vue?vue&type=script&lang=ts"
export * from "./IconBarcodeLinkHistory.vue?vue&type=script&lang=ts"
script.render = render

export default script